import React, { useState, useEffect } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,  Button,
  Table,
  CircularProgress,
  TableBody,
  TableCell,
  TableContainer,Menu,MenuItem,
  TableHead,
  TableRow,
  Paper,
  Avatar,
  TablePagination,  ListItemIcon,
  ListItemText,TextField
} from "@mui/material";
import {IconButton} from '@mui/material'
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useNavigate } from "react-router-dom";
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { GlobalStyles } from "@mui/system";
import GroupIcon from "@mui/icons-material/Group";
import EmojiPeopleIcon from "@mui/icons-material/EmojiPeople";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { TimePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { IoIosPeople } from "react-icons/io";
import { BsPersonCheckFill } from "react-icons/bs";
import { BsFillPersonXFill } from "react-icons/bs";
import { format } from "date-fns"; // Import the format function
import { useAuth } from "../../AuthProvider";



import ExcelJS from "exceljs";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import PresentToAllIcon from "@mui/icons-material/PresentToAll";
import SimCardDownloadIcon from "@mui/icons-material/SimCardDownload";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import FilePresentIcon from "@mui/icons-material/FilePresent";


import { useLocation } from "react-router-dom";


const baseUrl = process.env.REACT_APP_API_BASE_URL;
const SuperAdminOrganizationsList = () => {
  const [employeeCount, setEmployeeCount] = useState(0);
  const [organizationsCount, setOrganizationCount] = useState(0);
  const [organization, setOrganization  ] = useState([]);
  const [loader, setLoader] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const navigate = useNavigate();
  const [isEditingCheckIn, setIsEditingCheckIn] = useState(false); // State to toggle check-in input field
  const [isEditingCheckOut, setIsEditingCheckOut] = useState(false); // State to toggle check-out input field

  const { oId ,pId} = useAuth();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const dateRange = queryParams.get('dateRange');


 const [searchQuery, setSearchQuery] = useState("");


   const [exportAnchorEl, setExportAnchorEl] = useState(null);
  const isExportMenuOpen = Boolean(exportAnchorEl);

  const handleExportClick = (event) => {
    setExportAnchorEl(event.currentTarget);
  };

  const handleExportClose = () => {
    setExportAnchorEl(null);
  };
  const handleClose = () => {
    setExportAnchorEl(null);
  };



  const fetchAllOrganizationsList = async () => {
    try {
       setLoader(true);
      let endpoint = "";
     
      switch (dateRange) { // ✅ Changed to 'dateRange'
        case "SSC":
          endpoint = `${baseUrl}/api/superAdmin/getAllOrganisationList?boardAffiliation=SSC`;
          break;
        case "INTERMEDIATE":
          endpoint = `${baseUrl}/api/superAdmin/getAllOrganisationList?boardAffiliation=INTERMEDIATE`;
          break;
         case "All":
          endpoint = `${baseUrl}/api/superAdmin/getAllOrganisationList`;
          break;
       
        default:
          endpoint = `${baseUrl}/api/superAdmin/getAllOrganisationList`;
          break;
      }
 
      const response = await fetch(endpoint);
       if (!response.ok) {
        // If API returns non-2xx status
        console.warn("Organization List fetch failed with status:", response.status);
        setOrganization([]); // fallback to empty data
        return;
      }

      const data = await response.json();
      setOrganization(data || []);
    } catch (error) {
      console.error("Failed to fetch Data", error);
      setOrganization([]); // fallback to empty data
    } finally {
      setLoader(false);
    }
  };
 
  useEffect(() => {
    fetchAllOrganizationsList();
  }, [dateRange]);
 



const filteredResults = organization.filter((item) => {
  const query = searchQuery.toLowerCase();

  const schoolName = item.schoolName?.toLowerCase() || "";
  const contactNumber = item.primaryContact?.toString().toLowerCase() || "";
  const joinDate = item.joinDate?.toString().toLowerCase() || "";
  const boardAffiliation = item.boardAffiliation?.toLowerCase() || "";
  const feature = item.feature?.toLowerCase() || "";
  const plan = item.plan?.toLowerCase() || "";
  const schoolEmailId = item.schoolEmailId?.toLowerCase() || "";
  const schoolAddress = item.schoolAddress?.toLowerCase() || "";

  return (
    schoolName.includes(query) ||
    contactNumber.includes(query) ||
    joinDate.includes(query) ||
    boardAffiliation.includes(query) ||
    feature.includes(query) ||
    plan.includes(query) ||
    schoolEmailId.includes(query) ||
    schoolAddress.includes(query)
  );
});





const exportToExcel = () => {
  const orgData = filteredResults.map(
    ({
      orgId,
      schoolName,
      schoolEmailId,
      primaryContact,
      secondaryContact,
      boardAffiliation,
      schoolAddress,
      city,
      state,
      plan,
      feature,
      studentLimit,
      totalPresentStudents,
      totalPresentEmployees,
      totalPrincipals,
      joinDate,
      status,
    }) => ({
      OrgID: orgId,
      SchoolName: schoolName,
      SchoolEmail: schoolEmailId,
      PrimaryContact: primaryContact,
      SecondaryContact: secondaryContact,
      BoardAffiliation: boardAffiliation,
      SchoolAddress: schoolAddress,
      City: city,
      State: state,
      Plan: plan,
      Feature: feature,
      StudentLimit: studentLimit,
      TotalPresentStudents: totalPresentStudents,
      TotalPresentEmployees: totalPresentEmployees,
      TotalPrincipals: totalPrincipals,
      JoinDate: joinDate,
      Status: status,
    })
  );

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Organizations");

  worksheet.columns = Object.keys(orgData[0]).map((key) => ({
    header: key.replace(/([A-Z])/g, " $1").trim(),
    key,
    width: 25,
  }));

  orgData.forEach((row) => {
    worksheet.addRow(row);
  });

  // Style header row
  worksheet.getRow(1).eachCell((cell) => {
    cell.font = { bold: true };
    cell.alignment = { horizontal: "center" };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "87CEEB" },
    };
  });

  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "RegisteredOrganizationsList.xlsx";
    link.click();
  });

  handleExportClose();
};

  

  // Export to PDF
  const exportToPDF = () => {
    const doc = new jsPDF();
  
    // Title
    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");
    doc.text("Employees List", 10, 8);
  
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text("Generated On: ", 14, 16);
    doc.setFont("helvetica", "bold");
    doc.text(new Date().toLocaleDateString(), 40, 16);
  
    // Table
    doc.autoTable({
      startY: 20,
      head: [
        [
          "S.No",
          "Employee ID",
          "Name",
          "Gender",
          "Date of Birth",
          "Contact",
          "Email",
          "Father Name",
          "Joining Date",
        ],
      ],
      body: filteredResults.map((row, index) => [
        index + 1,
        row.employeeId,
        `${row.firstName} ${row.lastName}`,
        row.gender,
        row.dateofBirth,
        row.contactNumber1,
        row.emailId || "N/A",
        row.fatherName || "N/A",
        row.joiningDate,
      ]),
      styles: {
        lineWidth: 0.2,
        lineColor: "#B6B9CD",
      },
      headStyles: {
        fillColor: [63, 81, 181], // Dark Blue Header
        textColor: [255, 255, 255],
        halign: "center",
      },
      bodyStyles: {
        halign: "center",
      },
      theme: "grid",
    });
  
    doc.save("Employees_List.pdf");
    handleExportClose();
  };
  



  return (
    <Box p={2} marginTop={2}>
 
      <Box mt={5}>
        <Card
          sx={{
            backgroundColor: "white",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
          }}
        >




            <Box
  sx={{
    fontSize: "20px",
    fontWeight: "700",
    color: "#1f2937",
    marginBottom: "20px",
    display: "flex",
    alignItems: "center",
    gap: "2px",
    paddingTop:'5px'
  }}
>
  <IconButton onClick={() => navigate(-1)} sx={{ color: "#2e2a54" }}>
    <KeyboardBackspaceIcon fontSize="medium" />
  </IconButton>

  <Typography sx={{ fontSize: 18, textAlign: "left" }}>
    <strong>{`${dateRange} Registered Organization Details`}</strong>
  </Typography>
</Box>



<Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={2}
            >




           
           
          <TextField
      label="Search Organizaion Details"
      variant="outlined"
      size="small"
      style={{width:'200px', marginLeft:'15px'}}
      value={searchQuery}
      onChange={(e) => setSearchQuery(e.target.value)}
      fullWidth
    />


<Box>
<Button
                variant="contained"
                onClick={handleExportClick}
                sx={{
                  backgroundColor: "#3C3972",
                  fontWeight:'bold',
                  color: "#fff",
                  "&:hover": { backgroundColor: "#3C3972" },
                  
                  marginBottom: 2,
                  marginRight:2,
                }}
                startIcon={<PresentToAllIcon />}
              >
                Export
              </Button>

              <Menu
                anchorEl={exportAnchorEl}
                open={isExportMenuOpen}
                onClose={handleExportClose}
                sx={{
                  "& .MuiPaper-root": {
                    backgroundColor: "#f5f5f5",
                    borderRadius: "8px",
                  },
                }}
              >
                <MenuItem
                  onClick={exportToExcel}
                  sx={{
                    color: "#3f51b5",
                    fontWeight: "bold",
                    "&:hover": {
                      backgroundColor: "#e8f0fe",
                    },
                  }}
                >
                  <ListItemIcon sx={{ color: "#00796b" }}>
                    <SimCardDownloadIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Excel"
                    sx={{ fontWeight: "bold", color: "#00796b" }}
                  />
                </MenuItem>

                {/* <MenuItem
                  onClick={exportToPDF}
                  sx={{
                    color: "#d32f2f",
                    fontWeight: "bold",
                    "&:hover": {
                      backgroundColor: "#fdecea",
                    },
                  }}
                >
                  <ListItemIcon sx={{ color: "#d32f2f" }}>
                    <PictureAsPdfIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="PDF"
                    sx={{ fontWeight: "bold", color: "#d32f2f" }}
                  />
                </MenuItem> */}
{/* 
                <MenuItem
                  onClick={exportToJSON}
                  sx={{
                    color: "#388e3c",
                    fontWeight: "bold",
                    "&:hover": {
                      backgroundColor: "#e8f5e9",
                    },
                  }}
                >
                  <ListItemIcon sx={{ color: "#6a1b9a" }}>
                    <FilePresentIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="JSON"
                    sx={{ fontWeight: "bold", color: "#6a1b9a" }}
                  />
                </MenuItem> */}
              </Menu>


</Box>
</Box>













          <CardContent>
            <GlobalStyles
              styles={{
                ".custom-sidebar-scrollbar": {
                  scrollbarWidth: "thin", // For Firefox
                  scrollbarColor: "grey #e0e0e0",
                },
                ".custom-sidebar-scrollbar::-webkit-scrollbar": {
                  width: "6px", // For WebKit-based browsers
                },
                ".custom-sidebar-scrollbar::-webkit-scrollbar-track": {
                  background: "#f1f1f1", // Track color
                },
                ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb": {
                  backgroundColor: "grey", // Thumb color
                  borderRadius: "10px",
                },
                ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover": {
                  backgroundColor: "#555",
                },
              }}
            />
            <TableContainer
              component={Paper}
              style={{ maxHeight: "500px", overflowY: "auto" }}
              className="custom-sidebar-scrollbar"
            >
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    {[
                      "S.No",
                      "Registered Date",
                      "Organization Name",
                      "Feature",
                       "Plan",
                       "Principals",
                       "Students",
                       "Employees",
                        "Status",
                    ].map((header) => (
                      <TableCell
                        key={header}
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                          backgroundColor: "#fff9c4",
                          fontWeight: "Bold",
                          fontSize: "14px",
                        }}
                      >
                        {header}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loader ? (
                    <TableRow>
                      <TableCell
                        colSpan={8}
                        style={{ textAlign: "center", padding: "20px" }}
                      >
                        <Box
                          display="flex"
                          flexDirection="column"
                          alignItems="center"
                        >
                          <CircularProgress />
                          <Typography variant="body2" sx={{ mt: 1 }}>
                            Loading Data...
                          </Typography>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ) : filteredResults.length === 0 ? (
                    <TableRow>
                      <TableCell
                        colSpan={8}
                        style={{ textAlign: "center", padding: "20px" }}
                      >
                        No data available
                      </TableCell>
                    </TableRow>
                  ) : (
                    filteredResults.map((employee, index) => (
                      <TableRow
                        key={employee.id}
                        sx={{
                          backgroundColor: "white",
                          transition: "background-color 0.3s",
                          "&:hover": { backgroundColor: "#f5f5f5" }, // Hover effect
                         
                        }}
                      >
                        <TableCell
                          sx={{
    borderRight: "1px solid #ddd",
    padding: "4px",
    textAlign: "Center", // left-aligned looks better for long text
    maxWidth: "100px", // increase width if needed
    minWidth: "40px",
    whiteSpace: "normal",  // allow wrapping
    // wordBreak: "break-word", // break long words
    color: "black",
    fontSize: "13px",
  }}
                        >
                          {index + 1}
                        </TableCell>


                        <TableCell
                          sx={{
    borderRight: "1px solid #ddd",
    padding: "4px",
    textAlign: "Center", // left-aligned looks better for long text
    maxWidth: "150px", // increase width if needed
    minWidth: "100px",
    color: "black",
    fontSize: "13px",
  }}
                        >
                          {employee.joinDate}
                        </TableCell>

                        <TableCell
                          sx={{
    borderRight: "1px solid #ddd",
    padding: "4px",
    textAlign: "Center", // left-aligned looks better for long text
    maxWidth: "150px", // increase width if needed
    minWidth: "100px",
    whiteSpace: "normal",  // allow wrapping
    wordBreak: "break-word", // break long words
    color: "black",
    fontSize: "13px",
  }}
                        >
                          {employee.schoolName}
                        </TableCell>

                       <TableCell
  sx={{
    borderRight: "1px solid #ddd",
    padding: "4px",
    textAlign: "Center", // left-aligned looks better for long text
    maxWidth: "150px", // increase width if needed
    minWidth: "100px",
    whiteSpace: "normal",  // allow wrapping
    wordBreak: "break-word", // break long words
    color: "black",
    fontSize: "13px",
  }}
 
>
  {employee.feature || "NA"}
</TableCell>

                        <TableCell
                          sx={{
                            borderRight: "1px solid #ddd",
                            padding: "2px",
                            textAlign: "center",
                            maxWidth: "80px",
                            minWidth: "80px",
                            whiteSpace: "nowrap",
                             color:"black",
                            fontSize:'13px'
                          }}
                        >
                          {employee.plan || "NA"}
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: "1px solid #ddd",
                            padding: "2px",
                            textAlign: "center",
                            maxWidth: "80px",
                            minWidth: "80px",
                            whiteSpace: "nowrap",
                             color:"black",
                            fontSize:'13px'
                          }}
                        >
                          {employee.totalPrincipals || "NA"}
                        </TableCell>
                       <TableCell
  sx={{
    borderRight: "1px solid #ddd",
    padding: "4px",
    textAlign: "Center", // left-aligned looks better for long text
    maxWidth: "150px", // increase width if needed
    minWidth: "100px",
    whiteSpace: "normal",  // allow wrapping
    wordBreak: "break-word", // break long words
    color: "black",
    fontSize: "13px",
  }}
>
  {employee.totalPresentStudents || "NA"}
</TableCell>
 <TableCell
  sx={{
    borderRight: "1px solid #ddd",
    padding: "4px",
    textAlign: "Center", // left-aligned looks better for long text
    maxWidth: "150px", // increase width if needed
    minWidth: "100px",
    whiteSpace: "normal",  // allow wrapping
    wordBreak: "break-word", // break long words
    color: "black",
    fontSize: "13px",
  }}
>
  {employee.totalPresentEmployees || "NA"}
</TableCell>
 <TableCell
  sx={{
    borderRight: "1px solid #ddd",
    padding: "4px",
    textAlign: "Center", // left-aligned looks better for long text
    maxWidth: "150px", // increase width if needed
    minWidth: "100px",
    whiteSpace: "normal",  // allow wrapping
    wordBreak: "break-word", // break long words
    color: "black",
    fontSize: "13px",
  }}
>
  {employee.status || "NA"}
</TableCell>

                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      </Box>

   
      <ToastContainer />
    </Box>
  );
};


export default SuperAdminOrganizationsList;